"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Card = _interopRequireDefault(require("./Card"));
var _Grid = _interopRequireDefault(require("./Grid"));
var _Meta = _interopRequireDefault(require("./Meta"));
var Card = _Card["default"];
Card.Grid = _Grid["default"];
Card.Meta = _Meta["default"];
var _default = Card;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/card/index.js
// module id = 727
// module chunks = 0